// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wd-rich-text-editor-modal .modal-panel .modal-header{display:none}.wd-rich-text-editor-modal .modal-panel .modal-body{padding:0px}", ""]);
// Exports
module.exports = exports;
